import Component from '@glimmer/component';

import { fn } from '@ember/helper';
import LinksTo from 'ember-route-state/components/links-to.gjs';

import CIcon from 'rise-ui/components/c-icon.gjs';
import DateRangeInput from 'rise-ui/components/date-range-input.gjs';
import DateDropdown from 'rise-ui/components/time-series/selection/date-dropdown.gjs';
import qpDate from 'rise-ui/helpers/qp-date.js';
import qpDateIsEternal from 'rise-ui/helpers/qp-date-is-eternal.js';
import string from 'rise-ui/helpers/string.js';

export default class TimeSeriesSelectionOutputActionsDateComponent extends Component {
  <template>
    {{#let (qpDateIsEternal @dateRanges) as | isAllAvailable |}}
    <span class="c-time-series-date-range-input">
      <span class="c-time-series-date-range-input__dropdown">
        <DateDropdown
          @layer={{@layer}}
          @onOpen={{@onDropdownOpen}}
          @onSelection={{@onDropdownSelection}}
          @clearOption={{@clearOption}}
          @copyOption={{@copyOption}}
          @allOption={{@allOption}}
          @linkToClear={{@linkToClear}}
          @linkToCopy={{@linkToCopy}}
          @linkToWeek={{@linkToWeek}}
          @linkToMonth={{@linkToMonth}}
          @linkToYear={{@linkToYear}}
          @linkTo10Years={{@linkTo10Years}}
          @linkToAll={{@linkToAll}}
        >
          <:button><CIcon @icon="add-date" @text="Add Date" /></:button>
        </DateDropdown>
      </span>
      {{~#if isAllAvailable~}}
        <span class="c-time-series-date-range-input__all-available">
          All Available (Adding an output will select all available dates)
          <LinksTo @route={{@linkToClear}} @onClick={{@onDatesCleared}}>
            <CIcon @icon="exit" @text={{string "clear-default-dates"}} />
          </LinksTo>
        </span>
      {{~else~}}
        <DateRangeInput
          @from={{qpDate @dateRanges "from" "picker"}}
          @to={{qpDate @dateRanges "to" "picker"}}
          @onFromChange={{fn @onDatesChange "from"}}
          @onToChange={{fn @onDatesChange "to"}}
          @fromState={{@fromState}}
          @toState={{@toState}}
        />
      {{~/if~}}
    </span>
    {{/let}}
  </template>
}
